import { LadyProfileDto } from "@/features/lady-profile/models";

import { helper } from "../../helpers";

export const ladySliderV2MediaPredicates = {
  isLadyPhoto: helper.isLadyPhoto,
  isIntroVideo: helper.isIntroVideo,
};

export const ladySliderV2MediaFilter = (
  media: LadyProfileDto["forms"]["media"],
) => {
  return media.filter((item) => {
    return Object.values(ladySliderV2MediaPredicates).some((predicate) =>
      predicate(item),
    );
  });
};
